import React from 'react';
import { IconButton } from '@chakra-ui/react';
import { MdEdit } from 'react-icons/md';
import { useHistory } from 'react-router';

import { entityBaseBodyRender, TableColumn, dateTimeBodyRender, booleanBodyRender } from '@app/components/common/table';
import { ImageDescriptor, Stand } from '@app/api/models';
import GalleryModal from '@app/components/common/modals/gallery';

export const useColumns = (): TableColumn<Stand>[] => {
  const history = useHistory();
  return [
    {
      name: 'id',
      label: '#',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'model',
      label: 'Модель',
      options: {
        filter: {
          name: 'model_id',
          sourceName: 'stand_model',
          type: 'multi-select',
        },
        sort: true,
        customBodyRender: entityBaseBodyRender(false),
      },
    },
    {
      name: 'outlet',
      label: 'Торговая точка',
      options: {
        filter: {
          name: 'outlet_id',
          type: 'outlet',
        },
        sort: true,
        customBodyRender: entityBaseBodyRender(true),
      },
    },
    {
      name: 'distributor',
      label: 'Дистрибьютор',
      options: {
        filter: false,
        sort: false,
        customBodyRender: entityBaseBodyRender(true),
      },
    },
    {
      name: 'director',
      label: 'Директор',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'regional_manager',
      label: 'Региональный менеджер',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'territorial_manager',
      label: 'Территориальный менеджер',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'supervisor',
      label: 'Супервизор',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'sales_representative',
      label: 'Торговый представитель',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'address',
      label: 'Адрес',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'mount_dt',
      label: 'Дата установки',
      options: {
        filter: {
          type: 'date',
          name: 'mount_date',
        },
        sort: true,
        customBodyRender: dateTimeBodyRender(false, true),
      },
    },
    {
      name: 'update_dt',
      label: 'Дата последнего посещения',
      options: {
        filter: {
          type: 'date',
          name: 'update_date',
        },
        sort: true,
        customBodyRender: dateTimeBodyRender(false, true),
      },
    },
    {
      name: 'is_active',
      label: 'В наличии',
      options: {
        filter: false,
        sort: true,
        customBodyRender: booleanBodyRender(),
      },
    },
    {
      name: 'reason',
      label: 'Причина отсутствия',
      options: {
        filter: {
          name: 'reason_id',
          sourceName: 'reason',
          type: 'multi-select',
        },
        sort: true,
        customBodyRender: entityBaseBodyRender(false),
      },
    },
    {
      name: 'comment',
      label: 'Комментарий',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (text: string | undefined) => <>{text || ''}</>,
      },
    },
    {
      name: 'photos',
      label: 'Фото',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: Array<ImageDescriptor> | undefined) => {
          return <GalleryModal images={value || []} title="Фото" />;
        },
      },
    },
    {
      name: 'id',
      label: 'Изм.',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (id) => (
          <IconButton
            onClick={() => history.push('/equipments-stands/edit/' + id)} aria-label='edit'
          >
            <MdEdit />
          </IconButton>
        ),
      },
    },
    {
      name: 'outlet',
      label: 'Фильтр по названию ТТ',
      options: {
        filter: true,
        sort: false,
        hidden: true,
      },
    },
  ];
};
